<script>
    export let content;

    import ScrollDown from '../common/ScrollDown.svelte'
    import Button from '../common/Button.svelte'
    import WYSIWYGText from '../common/WYSIWYGText.svelte'

    const title = content.title;
    const text = content.text;
    const button = content.button;
    const anchor = content.anchor;
    const youtube = content.youtube;
    const youtubeID = youtube.slice(youtube.indexOf('=') + 1);

    const textBlocks = JSON.parse(text).blocks
</script>

<!-- Begin of a description section -->
<div class="section section-about section-cent fp-auto-height-responsive bg-primary" data-section={anchor}>
		
    <section class="content clearfix">
        <!-- Begin of Content -->
        <div class="content-centered c-columns fit">

            <div class="wrapper anim">
                <div class="desc-img desc-centered">

                    <iframe width="720" height="405" src="https://www.youtube.com/embed/{youtubeID}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    
                    <div class="w-text">
                        <!-- title and description -->
                        <div class="title-desc">

                            <span class="anim-wrapper">
                                <h2 class="border">{title}</h2>
                            </span>

                            <WYSIWYGText textBlocks={textBlocks} />

                        </div>

                        <!-- Action button -->
                        {#if button}
                        <Button link={button.Link}>{button.Text}</Button>
                        {/if}
                    </div>
                </div>

            </div>
        </div>
        <!-- End of Content -->
    </section>
</div>
<!-- End of a description section -->

<style lang='scss'>
    iframe {
        width: 100%;
        max-width: 720px;
        margin: 32px auto;
    }
</style>